export default {"src":"/_next/static/media/Cooper-Ray1.81d28dd7.JPG","height":464,"width":692};